import React, {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import { useHistory } from "react-router-dom";
import { UserService } from "../services/UserService";
import { Keycloaktokens, User } from "../storage/store";
import { isAdmin } from "../pages/Admin/paths";

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [profileName, setProfileName] = useState([]);
  const [configMain, setConfigMain] = useState();
  const [selectedItem, setSelectedItem] = useState(0);
  const [PropertyId_c, setPropertyId_c] = useState(null);
  const [floor, setFloor] = useState(null);
  const [selectedHouse, setSelectedHouse] = useState(null);
  const [selectedConfig, setSelectedConfig] = useState(null);
  // Who created a property ({ propertyId, ownedBy }), from the last config a
  // page loaded; usePropertyOwner reads it.
  const [propertyOwner, setPropertyOwner] = useState(null);
  const [allDevices, setAllDevices] = useState([]);
  const [offlineConfig, setOfflineConfig] = useState(null);
  // null until the subscription check answers, so the "contact HASHh" notice
  // doesn't flash while it loads.
  const [subscription, setSubscription] = useState(null);
  const [routineDevices, setRoutineDevices] = useState({
    on:[], 
    off:[],
    name:'',
    time:'',
    weekDays:[]
  });
  const [updateRoutine, setUpdateRoutine] = useState({
    on:[], 
    off:[],
    name:'',
    time:'',
    weekDays:[]
  });
  const [scheduleG, setScheduleG] = useState(null);
  const [device, setDevice] = useState();
  const [toggleTop, setToggleTop] = useState({
    color: 'blue', message:'Alert !', toggle:false
  });
  const [deviceSettings, setDeviceSettings] = useState();
  const [activePayload, setActivePayload] = useState();
  const [authToken, setAuthToken] = useState(Keycloaktokens.getToken());
  const history = useHistory();


  //This Functions goes to selectedecosystem to get propertey
  async function setPropertyIdandGetProperty(){
    const result = await UserService.getProperty();
      if (result) {
        let propertyId = User.getPropertyId();
        if(propertyId===null || propertyId===undefined){
          propertyId= result[0].property.id
          User.setPropertyId(propertyId);
          setPropertyId_c(propertyId);
        }
        propertyId = User.getPropertyId();
        return result;
    }
  }

  // The username comes first and on its own: the admin account's property list
  // is every sharing record in the system with no homes in it, so it isn't
  // loaded for admin, and it mustn't keep the username from being stored.
  async function getProperty() {
    try {
      const username = await UserService.getUserName();
      User.setUser(username);
    } catch (error) {
      // console.log("error...", error);
    }
    if (isAdmin()) return;
    try {
        await setPropertyIdandGetProperty();
    } catch (error) {
      // console.log("error...", error);
    }
  }

  //This Function has get the data of selected property
  const selectedPropertey = async () => {
    // No property list for the admin account (see getProperty).
    if (isAdmin()) return;
    try {
      let res = await UserService.getProperty();
      
      if (res && res.length > 0) {

        let propertyId = User.getPropertyId();
        if(propertyId===null || propertyId===undefined, propertyId==="undefined", propertyId==="null"){

          propertyId= res[0].property.id
          User.setPropertyId(propertyId);
          setPropertyId_c(propertyId);
        }
        propertyId = User.getPropertyId();
        let selected = res.filter(item=>item.property.id===propertyId);
        let other = res.filter(item=>item.property.id!==propertyId);

        res = [...selected, ...other];

        const newName = res.map((item) => ({
          id: item.property.id,
          name: item.property.name,
          role: item.role ?? null,
          // Set on the share of the user who created the property.
          superOwner: item.is_superOwner === true,
        }));
        

        setProfileName(newName);
      }
    } catch (error) {
      // The API answers 404 "No Properties Linked!" once the user has no home.
      if (error?.msg === "No Properties Linked!") setProfileName([]);
    }
  };

  //This function can handle the selected button in the header to get the selected item
  const handleEcoSystemSelection = useMemo(
    () => (e) => {
      e.preventDefault();
      const selectedSystem = e.target.value;
      User.setPropertyId(selectedSystem);
      setPropertyId_c(selectedSystem);

      getRooms();
    },
    []
  );

  const handleSubscription = async()=>{
    try {
      const user = await UserService.getSubscription();
      console.log(user);
      const dashboardPlan = user[0]?.subscriptions.filter(item=>{
        /* item.subscriptions */
        return (item.category==="dashboard" && new Date(item.validity_end) > new Date());
      })
      setSubscription(dashboardPlan.length > 0);
      console.log(dashboardPlan);
    } catch (error) {
      setSubscription(false);
    }
}

  // Switches the dashboard to another property from the Select House sheet.
  const selectProperty = (propertyId) => {
    User.setPropertyId(propertyId);
    setPropertyId_c(propertyId);
    getRooms();
  };
  //This function has give the rooms and floors in the selected propertey
  async function getRooms() {
    try {
      const propertyId = User.getPropertyId();
      const result = await UserService.getRooms(propertyId);
      if (result.floors) {
        setFloor(
          result.floors.map((el, index) => {
            return {
              floorId: el._id,
              label: el.name,
              rooms: el.rooms,
              index
            };
          })
        );
      }
    } catch (error) {
      // console.log("error...", error);
    }
  }

  // LoginView stores the Keycloak token and then navigates, so re-read it on navigation.
  useEffect(() => history.listen(() => setAuthToken(Keycloaktokens.getToken())), [history]);

  useEffect(() => {
    // Nothing to load until the user has signed in.
    if (!authToken) return;
    const pid = User.getPropertyId();
    getProperty();
    handleSubscription();
    if (selectedItem !== null) {
    }
  }, [selectedItem, authToken]);

  // This function gets a data from door sensor for day
  return (
    <UserContext.Provider
      value={{
        profileName,
        selectedItem,
        floor,
        setFloor,
        getProperty,
        setSelectedItem,
        selectedPropertey,
        handleEcoSystemSelection,
        selectProperty,
        getRooms,
        selectedHouse,
        setSelectedHouse,
        selectedConfig,
        setSelectedConfig,
        propertyOwner,
        setPropertyOwner,
        allDevices,
        setAllDevices,
        setOfflineConfig,
        routineDevices, setRoutineDevices,
        updateRoutine, setUpdateRoutine,
        device, setDevice,
        toggleTop, setToggleTop,
        deviceSettings, setDeviceSettings,
        scheduleG, setScheduleG,
        activePayload, setActivePayload,
        PropertyId_c, setPropertyId_c,
        subscription, setSubscription
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => {
  return useContext(UserContext);
};
